import { api } from './client';

export interface FinReportLine {
  line_code: string;
  line_name: string;
  section: string | null;
  order_no: number;
  is_total: boolean;
  is_negative: boolean;
  parent_line: string | null;
  column_start: string;
  column_end: string;
}

export interface FinReport {
  form_code: string;
  form_name: string;
  period_start: string;
  period_end: string;
  organization_ids: string[];
  scope: 'organization' | 'organizations' | 'tenant';
  lines: FinReportLine[];
}

export const financialReports = {
  get: (params: {
    form_code: '1' | '2' | '3' | '4';
    period_start: string;
    period_end: string;
    // Один з режимів:
    //  - organization_id: один — регламентний звіт;
    //  - organization_ids: кілька — зведений по обраних юрособах;
    //  - нічого не передано — наскрізний P&L по всьому tenant (тільки форми 2/3).
    organization_id?: string;
    organization_ids?: string[];
  }) =>
    api.get<FinReport>(`/financial-reports/${params.form_code}`, {
      params: {
        period_start: params.period_start,
        period_end: params.period_end,
        organization_id: params.organization_id,
        organization_ids: params.organization_ids,
      },
    }).then((r) => r.data),
};
